<div class="loader-overlay1"></div>

<div class="loader1">
  <div class="bar"></div>
  </div>
  <div class="loader">
    </div>
    
  <span id="router-main">
  
<router-outlet ></router-outlet>
</span>
